module.exports = __webpack_public_path__ + "img/ai-task-classification.e9c7c6a0.svg";